"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = appendToBody;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _react = _interopRequireWildcard(require("react")),
    _reactDom = require("react-dom");

function _createSuper(a) {
  return function () {
    var b,
        c = (0, _getPrototypeOf2["default"])(a);

    if (_isNativeReflectConstruct()) {
      var d = (0, _getPrototypeOf2["default"])(this).constructor;
      b = Reflect.construct(c, arguments, d);
    } else b = c.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, b);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}

var APPEND_CONTAINER_ID = "body-append-container",
    AppendedToBody = function (a) {
  function b() {
    var a;
    (0, _classCallCheck2["default"])(this, b), a = c.call(this);
    var d = document.getElementById(APPEND_CONTAINER_ID);
    if (d) return a._appendContainer = d, (0, _possibleConstructorReturn2["default"])(a);
    var e = document.createElement("div");
    return e.setAttribute("id", APPEND_CONTAINER_ID), a._appendContainer = e, document.body.appendChild(e), a;
  }

  (0, _inherits2["default"])(b, a);

  var c = _createSuper(b);

  return (0, _createClass2["default"])(b, [{
    key: "render",
    value: function render() {
      var a = this.props.children;
      return this._appendContainer ? (0, _reactDom.createPortal)(a, this._appendContainer) : null;
    }
  }]), b;
}(_react.Component);

function appendToBody(a) {
  return function (b) {
    return _react["default"].createElement(AppendedToBody, null, _react["default"].createElement(a, b));
  };
}